module.exports = require("./dz.d.ts");